// extracted by mini-css-extract-plugin
module.exports = {"container":"_01d657b","mobile":"_b78fde3","imgContainer":"_f83659f","marquee":"_bc8aaf0","loading":"_536fca3"};